import React from 'react'
import { Bar } from 'react-chartjs-2'
import { useSelector } from 'react-redux';
import styles from "../../../Pages/OptionsBoard/OptionsBoardStyles";
import { barOptions, barOptionsMobile, plugins } from './constant';


const AdminAccessBarChart = ({ chartData, chartOptionsMobile, chartOptions, barData }) => {
    /** @type {import('../../../typings').IStateReducerState} */
    const { isMobile } = useSelector(state => state.appReducer);
    return (
        <div>
            <div
                style={
                    isMobile
                        ? { ...styles.boardModalBigGraphMobile }
                        : { ...styles.boardModalBigGraphCallPage }
                }>
                <Bar
                    data={chartData}
                    options={isMobile ? chartOptionsMobile : chartOptions}
                    plugins={plugins}
                />
            </div>
            <div
                style={
                    isMobile
                        ? styles.boardModalSmallGraphMobile
                        : styles.boardModalSmallGraphCallpage
                }>
                <Bar
                    data={barData}
                    options={isMobile ? barOptionsMobile : barOptions}
                />
            </div>
        </div>
    )
}

export default AdminAccessBarChart


// WEBPACK FOOTER //
// ./src/components/Modals/VolumeModal/AdminAccessBarChart.jsx